import styled from 'styled-components';
import { format, isSameMonth, isSameDay } from 'date-fns';
import { spacing, subtitle2 } from 'ui/theme';
import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover';
import { PopoverEvents } from './PopoverEvents';
import { CalendarDay } from './CalendarDay';
import { CampaignEvent } from 'modules/campaignsCalendar/hooks';
import { parseDate } from 'utils/datetime';

const WeekdayHeader = styled.div`
  ${subtitle2};
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  padding: ${spacing.threeQuarter} 0;
`;

const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: ${spacing.single};
`;

const StyledPopoverContent = styled(PopoverContent)`
  padding: ${spacing.half};
`;

interface MonthlyViewProps {
  days: Date[];
  weekdays: string[];
  currentDate: Date;
  events?: CampaignEvent[];
}

export const MonthlyView = ({ days, weekdays, currentDate, events = [] }: MonthlyViewProps) => {
  const getEventsForDay = (day: Date) => {
    return events?.filter((event) => {
      const eventDate = parseDate(event.start);
      return isSameDay(eventDate, day);
    });
  };

  return (
    <div data-test="monthly-view">
      <WeekdayHeader>
        {weekdays.map((day) => (
          <div key={day}>{day}</div>
        ))}
      </WeekdayHeader>

      <DaysGrid>
        {days.map((day) => {
          const isToday = isSameDay(day, parseDate());
          const isDifferentMonth = !isSameMonth(day, currentDate);
          const dayEvents = getEventsForDay(day);
          return (
            <Popover key={`popover-${format(day, 'yyyy-MM-dd')}`}>
              <StyledPopoverContent>
                <p>{format(day, 'MMMM d, yyyy')}</p>
                <PopoverEvents events={dayEvents} />
              </StyledPopoverContent>
              <PopoverTrigger>
                <CalendarDay
                  day={day}
                  isToday={isToday}
                  isDifferentMonth={isDifferentMonth}
                  events={dayEvents}
                />
              </PopoverTrigger>
            </Popover>
          );
        })}
      </DaysGrid>
    </div>
  );
};
